import React, { useEffect, useRef, } from 'react'
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import SearchCard from './SearchCard/SearchCard';
import CategoryCard from '../../Catalog/CategoryCard/CategoryCard';
import { CATALOG_MAIN_LINK } from '../../../assets/utils/constants';

import './SearchDrop.css';

function SearchDrop({ isSearchPreloaderVisible, isOpened, setOpened, searchItems, Clear, searchRef, type, selectSearchItem, searchCategories }) {
    const dorpRef = useRef()

    useEffect(() => {
        const checkIfClickedOutside = e => {
            // If the menu is open and the clicked target is not within the menu,
            // then close the menu
            if (isOpened && searchRef.current && !searchRef.current.contains(e.target)) {
                closeDropdown()
            }
        }

        document.addEventListener("mousedown", checkIfClickedOutside)

        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [isOpened])


    function closeDropdown() {
        console.log('sas')
        Clear()
        setOpened(false)
        setTimeout(() => {
            setOpened(false)
        }, 1);
    }

    return (
        <div ref={dorpRef} className={`search-drop ${isOpened ? 'search-drop_active' : 'search-drop_inactive'}`}>
            {isSearchPreloaderVisible ?
                <div className='search-drop__preloader'>
                    <MiniPreloader />
                </div>
                :
                <div className='search-drop__content'>
                    {searchCategories && searchCategories.length > 0 && type === "search" ?
                        <div className='search-drop__block'>
                            <p className='search-drop__title'>Categories</p>
                            <div className='search-drop__cats'>
                                {searchCategories.map((category, i) => (
                                    <div onClick={closeDropdown}>
                                        <CategoryCard isSearch category={category} levels={[CATALOG_MAIN_LINK, ...category.parents.slice(1).map((parent) => parent.translit_name)]} />
                                    </div>


                                ))
                                }
                            </div>
                        </div>
                        : null}
                    <div className='search-drop__block'>
                        <p className='search-drop__title'>Products</p>
                        <div className='search-drop__cards'>
                            {searchItems && searchItems.length > 0 ?
                                searchItems.map((item, i) => (
                                    <SearchCard selectSearchItem={selectSearchItem} type={type} closeDropdown={closeDropdown} item={item} key={`header-search-drop-card${i}${item._id}`} />
                                ))
                                :
                                <div className='search-drop__no-cards'>
                                    <p className='search-drop__no-cards-text'>Nothing was found</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default SearchDrop;